import {WithoutSummaryModel} from '../../../../entity/dto/plain/withoutSummary.model';
import {AudioRecordSummaryModel} from '../../../record/api/model/audioRecordSummary.model';

export class AudioTranscriptionModel extends WithoutSummaryModel {
    audioRecord: AudioRecordSummaryModel;
    transcription: string;
    context: string;
}
